import { Pledge } from "../interfaces";

export const  validateUser =(id: string ,pledgeData :Pledge[]):null|Pledge => {
    let pledge = pledgeData?.filter((pledge: Pledge) => {
      return pledge.poolId === id && pledge.whitelist !== null ;
    });
    if (pledge?.length >= 1) {
      return pledge[0];
    } else {
      return null;
    }
  }

  export const  validateUserWhitelist =(id: string ,pledgeData :Pledge[]):null|Pledge => {
    let pledge = pledgeData?.filter((pledge: Pledge) => {
      return pledge.poolId === id  ;
    });
    if (pledge?.length >= 1) { 
      return pledge[0];
    } else {
      return null;
    }
  }
  